import { dpActions } from '../../../Reducers/DPReducer/dpReducer';

// ✅ Re-export ONLY what actually exists
export const {
  initDP,
  addProduct,
  updateProductQty,
  removeProduct,
  clearCartItems,
  selectShipToParty,
  setShipToPartyDetails,
  moveProductsToShipToParty,
  setDPDetails,
  setLoading,
  setError,
  hydrateDpFromOrder,
  resetDP,
  
} = dpActions;

/* ---------------- LEGACY COMPATIBILITY ---------------- */

export const addProductToCart = (product, shipToPartyId) =>
  addProduct(product, shipToPartyId);

export const removeProductFromCart = (productId) =>
  removeProduct(productId);

export const hydrateDpFromOrderAction = (payload) => 
  hydrateDpFromOrder(payload);

// Cart clear = full DP reset
export const clearCart = () => resetDP();

/* ---------------- CATEGORY (UNCHANGED) ---------------- */

export const setSelectedCategory = (category) => ({
  type: 'SET_SELECTED_CATEGORY',
  payload: category
});

export const setSelectedFormType = (formType) => ({
  type: 'SET_SELECTED_FORM_TYPE',
  payload: formType
});

export const setSkuCategories = (categories) => ({
  type: 'SET_SKU_CATEGORIES',
  payload: categories
});
export const resetSelectedShipToParty = () => ({
  type: 'RESET_SELECTED_SHIP_TO_PARTY'
});
export const removeShipToParty = (id) => ({
  type: 'REMOVE_SHIP_TO_PARTY',
  payload: {id}
});

export const setDpRouteSource = (source) => ({
  type: 'SET_DP_ROUTE_SOURCE',
  payload: source,
});

export const resetDpRouteSource = () => ({
  type: 'RESET_DP_ROUTE_SOURCE',
});

export const setReferencePricingGeography = (pricingGeoData) => ({
  type: 'SET_REFERENCE_PRICING_GEOGRAPHY',
  payload: pricingGeoData,
});

export const resetReferencePricingGeography = () => ({
  type: 'RESET_REFERENCE_PRICING_GEOGRAPHY',
});

export const showPriceChange = (value) => ({
  type: 'SET_SHOW_PRICE_CHANGE',
  payload: value,
});

export const resetShowPriceChange = () => ({
  type: 'RESET_SHOW_PRICE_CHANGE',
});

export const setMoQData = (moqData) => ({
  type: 'SET_MOQ_DATA',
  payload: moqData
});

export const clearMoQData = () => ({
  type: 'SET_MOQ_DATA',
  payload: {
    min_po_quantity: null,
    max_po_quantity: null,
    min_order_quantity: null,
    max_order_quantity: null,
    min_order_value: null,
    max_order_value: null
  }
});

export const setMaxDPQuantityAllowed = (quantity) => ({
  type: 'SET_MAX_DP_QUANTITY_ALLOWED',
  payload: quantity
});

export const resetMaxDPQuantityAllowed = () => ({
  type: 'RESET_MAX_DP_QUANTITY_ALLOWED'
});

export const setActiveTabIndex = (shipToPartyId, activeTabIndex) => ({
  type: 'SET_ACTIVE_TAB_INDEX',
  payload: { shipToPartyId, activeTabIndex }
});